import styled from 'styled-components';

export const DocumentViewer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: stretch;
    background-color: ${({ theme }) => theme.uiBricks?.leftRailBackgroundColor || '#e9eaec'};
    border: ${({ theme }) =>
        `1px solid ${theme.uiBricks?.tradeInSummaryTradeInVehicleVehicleInfoKbbTradeInAdvisorContainerBorderColor || '#d6d8db'}`};
    border-radius: 8px;
    box-sizing: border-box;
    position: relative;
`;

export const PdfIframe = styled.iframe`
    width: 100%;
    border: none;
    height: 96vh;
`;
